import { useEffect } from 'react';
import NProgress from 'nprogress';
import Spinner from '../Spinner';

function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return <Spinner />;
}

export default SuspenseLoader;
